import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M29.6986,8.01a1.002,1.002,0,0,0,0-1.43l-4.28-4.28a.9993.9993,0,0,0-.71-.3,1.0224,1.0224,0,0,0-.72.3l-3.56,3.57,5.71,5.71Z"/><path d="M28.999,28h-1a2.8417,2.8417,0,0,1-1.6152-.5225,9.9125,9.9125,0,0,0,1.7432-5.4257,5.057,5.057,0,0,0-.669-2.7,2.9127,2.9127,0,0,0-4.918,0,5.057,5.057,0,0,0-.6689,2.7,9.9125,9.9125,0,0,0,1.7432,5.4257,2.1572,2.1572,0,0,1-3.1368-.3574,4.108,4.108,0,0,1-.4033-.6572,5.5251,5.5251,0,0,0,.3-1.6817c0-1.3144-.74-1.7812-1.375-1.7812s-1.375.4668-1.375,1.7812a5.5341,5.5341,0,0,0,.2989,1.6827,4.0908,4.0908,0,0,1-.4024.6562A1.913,1.913,0,0,1,15.999,28h-6.29L24.7086,13.01l-5.71-5.71L3.0086,23.28a1.1511,1.1511,0,0,0-.14.17c-.02.05-.05.11-.08.17a.6154.6154,0,0,0-.07.23l-.71,5a1.016,1.016,0,0,0,.9826,1.1464L3,30H15.999a3.84,3.84,0,0,0,3.002-1.5283A3.8192,3.8192,0,0,0,21.999,30a4.831,4.831,0,0,0,3-1.0527,4.831,4.831,0,0,0,3,1.0527h1a1,1,0,0,0,0-2Zm-4-2.05a7.9357,7.9357,0,0,1-1.1279-3.8984,3.1566,3.1566,0,0,1,.3584-1.63.9128.9128,0,0,1,1.5391,0,3.1566,3.1566,0,0,1,.3584,1.63A7.9348,7.9348,0,0,1,24.999,25.95Z"/>';
export var DrawSVG = function DrawSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
DrawSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(DrawSVG);